import { html, rune, View } from 'rune-ts';
import klass from './StatisticsSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import Swiper from 'swiper';
import { EffectFade, Pagination } from 'swiper/modules';
import { htmlIf } from '../../../../../shared/util';
import { getResizedUrl } from '../../../../../shared/util/image';

export class StatisticsSection extends View {
  swiper?: Swiper;

  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      statistics_title: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}statistics_title`),
      ),
      statistics_description: html.preventEscape(ET('mps2::landing::plus::statistics_description')),
      statistics_chart_title: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}statistics_chart_title`),
      ),
      statistics_chart_description: html.preventEscape(
        ET('mps2::landing::plus::statistics_chart_description'),
      ),
      statistics_chart_source: html.preventEscape(ET('mps2::landing::plus::statistics_chart_source')),
      statistics_circle_title: html.preventEscape(ET('mps2::landing::plus::statistics_circle_title')),
      statistics_circle_description: html.preventEscape(
        ET('mps2::landing::plus::statistics_circle_description'),
      ),
      statistics_circle_source: html.preventEscape(ET('mps2::landing::plus::statistics_circle_source')),
    };

    return html`
      <section class="${klass.container} swiper statistics_swiper">
        <div class="${klass.title_wrapper}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.statistics_title}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_medium', mo: '14_medium' })}">
            ${texts.statistics_description}
          </div>
        </div>
        <div class="${klass.content} swiper-wrapper">
          <div class="${klass.slide} swiper-slide">
            <div class="${klass.statistics} ">
              <div class="${klass.statistics_title_wrapper}">
                <div
                  class="${klass.statistics_title} ${typoPcMo({ is_mobile, pc: '40_bold', mo: '16_bold' })}"
                >
                  ${texts.statistics_chart_title}
                </div>
                <div
                  class="${klass.statistics_description} ${typoPcMo({
                    is_mobile,
                    pc: '20_medium',
                    mo: '14_medium',
                  })}"
                >
                  ${texts.statistics_chart_description}
                </div>
                <div
                  class="${klass.statistics_source} ${typoPcMo({
                    is_mobile,
                    pc: '14_medium',
                    mo: '12_medium',
                  })}"
                >
                  ${texts.statistics_chart_source}
                </div>
              </div>
              <div class="${klass.chart}">
                <img
                  src="${getResizedUrl({
                    url: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section2/chart.png`,
                    width: 1920 * 2,
                    format: 'webp',
                    quality: 85,
                  })}"
                  alt="마플샵 IP 커머스 차트"
                />
              </div>
            </div>
          </div>
          <div class="${klass.slide} swiper-slide">
            <div class="${klass.statistics} swiper-slide">
              <div class="${klass.statistics_title_wrapper}">
                <div
                  class="${klass.statistics_title} ${typoPcMo({ is_mobile, pc: '40_bold', mo: '16_bold' })}"
                >
                  ${texts.statistics_circle_title}
                </div>
                <div
                  class="${klass.statistics_description} ${typoPcMo({
                    is_mobile,
                    pc: '20_medium',
                    mo: '14_medium',
                  })}"
                >
                  ${texts.statistics_circle_description}
                </div>
                <div
                  class="${klass.statistics_source} ${typoPcMo({
                    is_mobile,
                    pc: '14_medium',
                    mo: '12_medium',
                  })}"
                >
                  ${texts.statistics_circle_source}
                </div>
              </div>
              <div class="${klass.chart}">
                <img
                  src="${getResizedUrl({
                    url: `//s3.marpple.co/files/u_14345/2024/6/original/plus/section2/${
                      is_mobile ? 'mo_' : ''
                    }circle.png`,
                    width: 1920 * 2,
                    format: 'webp',
                    quality: 85,
                  })}"
                  alt="마플샵 IP 커머스 차트"
                />
              </div>
            </div>
          </div>
        </div>
        ${htmlIf(html`<div class="swiper-pagination ${klass.pagination}"></div>`, is_mobile)}
      </section>
    `;
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    if (is_mobile) {
      this.swiper = this._onLoadAdSwiper();
    }
  }

  private _onLoadAdSwiper() {
    return new Swiper('.statistics_swiper', this._createSwiperOption());
  }

  private _createSwiperOption() {
    return {
      modules: [Pagination, EffectFade],
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    };
  }
}
